import { useState } from 'react';
import Sidebar from './Sidebar';
import SubNav from './SubNav';
import Header from './Header';

function MainLayout({ children }) {
  // Controls the secondary-nav overlay (e.g. Devices sub-menu). `null`
  // means closed; otherwise it holds the parent nav item's `id`.
  const [openedParentId, setOpenedParentId] = useState(null);

  return (
    <>
      <Sidebar
        openedParentId={openedParentId}
        onOpenSub={setOpenedParentId}
        onCloseSub={() => setOpenedParentId(null)}
      />
      <SubNav
        openedParentId={openedParentId}
        onClose={() => setOpenedParentId(null)}
      />
      <main className="main-content">
        <Header />
        <div className="page-content">
          {children}
        </div>
      </main>
    </>
  );
}

export default MainLayout;
